import {
  ChangeDetectorRef,
  Directive,
  ElementRef,
  HostBinding,
  Input,
  OnDestroy,
  OnInit,
} from '@angular/core';

@Directive({
  selector: '[xObserveHeight]',
  standalone: true,
})
export class ObserveHeightDirective implements OnInit, OnDestroy {
  @Input('xObserveHeight') targetHeight = 0;
  @Input() heightClass = 'height-met';

  private resizeObserver!: ResizeObserver;
  private isHeightMet = false;

  @HostBinding('class')
  get boundClass(): string {
    return this.isHeightMet ? this.heightClass : '';
  }

  constructor(
    private el: ElementRef,
    private cd: ChangeDetectorRef,
  ) {}

  ngOnInit(): void {
    this.resizeObserver = new ResizeObserver((entries) => {
      for (const entry of entries) {
        const currentHeight = entry.contentRect.height;
        this.isHeightMet = currentHeight >= this.targetHeight;
        this.cd.detectChanges();
      }
    });

    this.resizeObserver.observe(this.el.nativeElement);
  }

  ngOnDestroy(): void {
    this.resizeObserver.disconnect();
  }
}
